// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* File: /opt/dev_environment/assets/workspace/app-init/src/pages/VerbenPage/StagedVerbsSection.css */

/* ============================================
   STAGED VERBS SECTION
   ============================================ */

.staged-verbs {
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
}

/* ---- Add Verb Input ---- */
.staged-verbs__add-section {
  background-color: var(--color-card-white);
  border-radius: var(--radius-lg);
  padding: var(--space-lg);
  box-shadow: var(--shadow-md);
}

.staged-verbs__add-title {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  margin-bottom: var(--space-md);
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

.staged-verbs__add-form {
  display: flex;
  gap: var(--space-sm);
  align-items: stretch;
}

.staged-verbs__add-input {
  flex: 1 1;
  padding: var(--space-sm) var(--space-md);
  border: 1.5px solid var(--color-border);
  border-radius: var(--radius-md);
  font-size: var(--font-size-base);
  color: var(--color-text-primary);
  background-color: var(--color-card-white);
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
  appearance: none;
  font-family: inherit;
}

.staged-verbs__add-input:focus {
  outline: none;
  border-color: var(--color-wood-medium);
  box-shadow: 0 0 0 3px rgba(139, 94, 60, 0.15);
}

.staged-verbs__add-input::placeholder {
  color: var(--color-text-light);
}

.staged-verbs__add-input:disabled {
  opacity: 0.6;
  background-color: var(--color-progress-bg);
}

.staged-verbs__add-btn {
  padding: var(--space-sm) var(--space-lg);
  border-radius: var(--radius-md);
  border: none;
  background-color: var(--color-wood-medium);
  color: var(--color-text-on-wood);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  font-family: inherit;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: var(--space-xs);
}

.staged-verbs__add-btn:active:not(:disabled) {
  background-color: var(--color-wood-dark);
  transform: scale(0.98);
}

.staged-verbs__add-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ---- Processing State ---- */
.staged-verbs__processing {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  padding: var(--space-md);
  background-color: rgba(255, 143, 0, 0.08);
  border: 1.5px solid var(--color-accent);
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-accent);
  animation: staged-pulse 1.5s ease-in-out infinite;
}

@keyframes staged-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

.staged-verbs__processing-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: staged-spin 0.6s linear infinite;
}

@keyframes staged-spin {
  to { transform: rotate(360deg); }
}

/* ---- Success Message ---- */
.staged-verbs__success {
  padding: var(--space-md);
  background-color: rgba(76, 175, 80, 0.08);
  border: 1.5px solid var(--color-success);
  border-radius: var(--radius-md);
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
  animation: staged-fade-in 0.3s ease-out;
}

.staged-verbs__success-header {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  color: var(--color-success);
}

.staged-verbs__success-detail {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  line-height: var(--line-height-normal);
}

.staged-verbs__success-detail strong {
  color: var(--color-text-primary);
}

.staged-verbs__success-actions {
  display: flex;
  gap: var(--space-sm);
  padding-top: var(--space-xs);
}

.staged-verbs__success-btn {
  padding: var(--space-xs) var(--space-md);
  border-radius: var(--radius-md);
  border: 1.5px solid var(--color-border);
  background-color: var(--color-card-white);
  color: var(--color-text-primary);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  font-family: inherit;
}

.staged-verbs__success-btn:active {
  background-color: var(--color-progress-bg);
}

.staged-verbs__success-btn--primary {
  background-color: var(--color-wood-medium);
  color: var(--color-text-on-wood);
  border-color: var(--color-wood-medium);
}

.staged-verbs__success-btn--primary:active {
  background-color: var(--color-wood-dark);
}

/* ---- Error Message ---- */
.staged-verbs__error {
  padding: var(--space-md);
  background-color: rgba(229, 57, 53, 0.08);
  border: 1.5px solid var(--color-error);
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-error);
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  margin-top: var(--space-md);
}

/* ---- Duplicate Warning ---- */
.staged-verbs__duplicate {
  padding: var(--space-md);
  background-color: rgba(255, 143, 0, 0.08);
  border: 1.5px solid var(--color-accent);
  border-radius: var(--radius-md);
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
}

.staged-verbs__duplicate-header {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  color: var(--color-accent);
}

.staged-verbs__duplicate-info {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.staged-verbs__duplicate-actions {
  display: flex;
  gap: var(--space-sm);
}

/* ---- Similar Verbs ---- */
.staged-verbs__similar {
  padding: var(--space-sm) var(--space-md);
  background-color: rgba(66, 165, 245, 0.06);
  border: 1px solid rgba(66, 165, 245, 0.3);
  border-radius: var(--radius-md);
  font-size: var(--font-size-xs);
  color: var(--color-text-secondary);
}

.staged-verbs__similar-title {
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  margin-bottom: var(--space-xs);
}

.staged-verbs__similar-list {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-xs);
}

.staged-verbs__similar-item {
  padding: 2px var(--space-sm);
  background-color: var(--color-card-white);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-full);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
}

/* ---- Staged Verbs List ---- */
.staged-verbs__list-section {
  background-color: var(--color-card-white);
  border-radius: var(--radius-lg);
  padding: var(--space-lg);
  box-shadow: var(--shadow-md);
}

.staged-verbs__list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--space-md);
  flex-wrap: wrap;
  gap: var(--space-sm);
}

.staged-verbs__list-title {
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

.staged-verbs__list-actions {
  display: flex;
  gap: var(--space-sm);
  align-items: center;
}

/* ---- Status Filter ---- */
.staged-verbs__filter-bar {
  display: flex;
  gap: var(--space-xs);
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  padding: var(--space-xs) 0;
  margin-bottom: var(--space-sm);
}

.staged-verbs__filter-bar::-webkit-scrollbar {
  display: none;
}

.staged-verbs__filter-btn {
  padding: var(--space-xs) var(--space-sm);
  border-radius: var(--radius-full);
  border: 1.5px solid var(--color-border);
  background-color: var(--color-card-white);
  color: var(--color-text-secondary);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  transition: all var(--transition-fast);
  white-space: nowrap;
  -webkit-tap-highlight-color: transparent;
  font-family: inherit;
}

.staged-verbs__filter-btn--active {
  background-color: var(--color-wood-medium);
  color: var(--color-text-on-wood);
  border-color: var(--color-wood-medium);
}

/* ---- Import Selected Button ---- */
.staged-verbs__import-selected-btn {
  padding: var(--space-xs) var(--space-md);
  border-radius: var(--radius-md);
  border: none;
  background-color: var(--color-success);
  color: white;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  font-family: inherit;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: var(--space-xs);
}

.staged-verbs__import-selected-btn:active:not(:disabled) {
  opacity: 0.85;
  transform: scale(0.98);
}

.staged-verbs__import-selected-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ---- Verb List Table ---- */
.staged-verbs__table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  overflow: hidden;
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border);
}

.staged-verbs__table thead {
  background: linear-gradient(180deg, #f5efe6 0%, #ede4d6 100%);
}

.staged-verbs__table th {
  padding: var(--space-sm) var(--space-sm);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-bold);
  color: var(--color-wood-dark);
  text-align: left;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  border-bottom: 2px solid var(--color-border);
  white-space: nowrap;
}

.staged-verbs__table th:first-child {
  width: 36px;
  text-align: center;
}

.staged-verbs__table td {
  padding: var(--space-sm) var(--space-sm);
  font-size: var(--font-size-sm);
  color: var(--color-text-primary);
  border-bottom: 1px solid var(--color-border);
  vertical-align: middle;
}

.staged-verbs__table tbody tr:last-child td {
  border-bottom: none;
}

.staged-verbs__table tbody tr:nth-child(even) {
  background-color: rgba(245, 239, 230, 0.4);
}

.staged-verbs__table-checkbox {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: var(--color-wood-medium);
}

.staged-verbs__table-checkbox:disabled {
  cursor: not-allowed;
  opacity: 0.4;
}

/* ---- Status Badge ---- */
.staged-verbs__status-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px var(--space-sm);
  border-radius: var(--radius-full);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-bold);
  white-space: nowrap;
}

/* ---- Table Action Buttons ---- */
.staged-verbs__table-actions {
  display: flex;
  gap: 2px;
  white-space: nowrap;
}

.staged-verbs__table-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: var(--radius-sm);
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: var(--font-size-sm);
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  padding: 0;
}

.staged-verbs__table-action-btn:hover {
  background-color: var(--color-progress-bg);
}

.staged-verbs__table-action-btn:active {
  transform: scale(0.92);
}

.staged-verbs__table-action-btn--delete {
  color: var(--color-error);
}

.staged-verbs__table-action-btn--delete:hover {
  background-color: rgba(229, 57, 53, 0.1);
}

.staged-verbs__table-action-btn--retry {
  color: var(--color-accent);
}

.staged-verbs__table-action-btn--retry:hover {
  background-color: rgba(255, 143, 0, 0.1);
}

/* ---- Verb Group Badge ---- */
.staged-verbs__group-badge {
  display: inline-block;
  padding: 1px var(--space-xs);
  border-radius: var(--radius-sm);
  font-size: 0.6rem;
  font-weight: var(--font-weight-bold);
  color: var(--color-text-light);
  background-color: var(--color-progress-bg);
}

/* ---- Empty State ---- */
.staged-verbs__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--space-xl) var(--space-md);
  gap: var(--space-sm);
  text-align: center;
  color: var(--color-text-secondary);
}

.staged-verbs__empty-icon {
  font-size: 2rem;
}

.staged-verbs__empty-text {
  font-size: var(--font-size-sm);
  line-height: var(--line-height-normal);
  max-width: 280px;
}

/* ============================================
   VERB DETAIL DIALOG
   ============================================ */

.verb-detail-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 200;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--space-md);
  animation: overlay-fade-in 0.2s ease-out;
}

.verb-detail-dialog {
  background-color: var(--color-card-white);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  width: 100%;
  max-width: 440px;
  max-height: 85vh;
  overflow-y: auto;
  animation: dialog-slide-up 0.25s ease-out;
  display: flex;
  flex-direction: column;
}

.verb-detail-dialog__header {
  padding: var(--space-lg) var(--space-lg) var(--space-sm);
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: sticky;
  top: 0;
  background-color: var(--color-card-white);
  z-index: 2;
  border-bottom: 1px solid var(--color-border);
}

.verb-detail-dialog__header-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.verb-detail-dialog__title {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-extrabold);
  color: var(--color-wood-medium);
}

.verb-detail-dialog__subtitle {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  font-weight: var(--font-weight-semibold);
}

.verb-detail-dialog__meta {
  display: flex;
  gap: var(--space-xs);
  align-items: center;
  margin-top: var(--space-xs);
}

.verb-detail-dialog__close {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  font-size: var(--font-size-lg);
  color: var(--color-text-light);
  cursor: pointer;
  transition: all var(--transition-fast);
  flex-shrink: 0;
  font-family: inherit;
}

.verb-detail-dialog__close:hover {
  background-color: var(--color-progress-bg);
  color: var(--color-text-primary);
}

.verb-detail-dialog__body {
  padding: var(--space-md) var(--space-lg) var(--space-lg);
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
}

/* ---- Tense Selection ---- */
.verb-detail__tense-section {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
}

.verb-detail__tense-section-label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.verb-detail__tense-list {
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
}

.verb-detail__tense-item {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  padding: var(--space-xs) var(--space-sm);
  border-radius: var(--radius-md);
  transition: background-color var(--transition-fast);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.verb-detail__tense-item:hover {
  background-color: rgba(139, 94, 60, 0.04);
}

.verb-detail__tense-checkbox {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: var(--color-wood-medium);
  flex-shrink: 0;
}

.verb-detail__tense-label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
  flex: 1 1;
}

.verb-detail__tense-german {
  font-size: var(--font-size-xs);
  color: var(--color-text-light);
}

/* ---- Conjugation Tables ---- */
.verb-detail__conjugation-section {
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
}

.verb-detail__conjugation-table-wrapper {
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  overflow: hidden;
}

.verb-detail__conjugation-table-header {
  padding: var(--space-sm) var(--space-md);
  background: linear-gradient(180deg, #f5efe6 0%, #ede4d6 100%);
  border-bottom: 1px solid var(--color-border);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.verb-detail__conjugation-table-title {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-bold);
  color: var(--color-wood-dark);
}

.verb-detail__conjugation-table-german {
  font-size: var(--font-size-xs);
  color: var(--color-text-light);
}

.verb-detail__conjugation-table {
  width: 100%;
  border-collapse: collapse;
}

.verb-detail__conjugation-table td {
  padding: var(--space-xs) var(--space-sm);
  font-size: var(--font-size-sm);
  border-bottom: 1px solid var(--color-border);
  vertical-align: middle;
}

.verb-detail__conjugation-table tr:last-child td {
  border-bottom: none;
}

.verb-detail__conjugation-table tr:nth-child(even) {
  background-color: rgba(245, 239, 230, 0.3);
}

.verb-detail__conj-person {
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-secondary);
  width: 70px;
  white-space: nowrap;
}

.verb-detail__conj-italian {
  font-weight: var(--font-weight-bold);
  color: var(--color-wood-medium);
}

.verb-detail__conj-german {
  font-size: var(--font-size-xs);
  color: var(--color-text-light);
}

/* ---- Detail Footer Actions ---- */
.verb-detail-dialog__footer {
  padding: var(--space-md) var(--space-lg);
  border-top: 1px solid var(--color-border);
  display: flex;
  gap: var(--space-sm);
  position: sticky;
  bottom: 0;
  background-color: var(--color-card-white);
  z-index: 2;
}

.verb-detail__action-btn {
  flex: 1 1;
  padding: var(--space-md);
  border-radius: var(--radius-md);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  border: none;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  font-family: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-xs);
}

.verb-detail__action-btn--delete {
  background-color: transparent;
  color: var(--color-error);
  border: 1.5px solid var(--color-error);
}

.verb-detail__action-btn--delete:active {
  background-color: rgba(229, 57, 53, 0.1);
}

.verb-detail__action-btn--import {
  background-color: var(--color-success);
  color: white;
  box-shadow: var(--shadow-sm);
}

.verb-detail__action-btn--import:active:not(:disabled) {
  opacity: 0.85;
}

.verb-detail__action-btn--import:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ============================================
   IMPORT DIALOG
   ============================================ */

.import-dialog {
  background-color: var(--color-card-white);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  width: 100%;
  max-width: 380px;
  padding: var(--space-lg);
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
  animation: dialog-slide-up 0.25s ease-out;
}

.import-dialog__icon {
  font-size: 2.5rem;
  text-align: center;
  line-height: 1;
}

.import-dialog__title {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-primary);
  text-align: center;
}

.import-dialog__summary {
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
  padding: var(--space-sm) var(--space-md);
  background-color: rgba(139, 94, 60, 0.06);
  border-radius: var(--radius-md);
}

.import-dialog__summary-item {
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
  display: flex;
  align-items: center;
  gap: var(--space-xs);
}

.import-dialog__summary-item strong {
  color: var(--color-text-primary);
}

.import-dialog__total {
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  color: var(--color-wood-medium);
  text-align: center;
  padding: var(--space-sm) 0;
  border-top: 1px solid var(--color-border);
  margin-top: var(--space-xs);
}

/* ---- Tense Override ---- */
.import-dialog__tense-override {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
}

.import-dialog__tense-override-label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-bold);
  color: var(--color-text-secondary);
}

.import-dialog__tense-chips {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-xs);
}

.import-dialog__tense-chip {
  padding: var(--space-xs) var(--space-sm);
  border-radius: var(--radius-full);
  border: 1.5px solid var(--color-border);
  background-color: var(--color-card-white);
  color: var(--color-text-secondary);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  cursor: pointer;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  font-family: inherit;
}

.import-dialog__tense-chip--selected {
  background-color: var(--color-wood-medium);
  color: var(--color-text-on-wood);
  border-color: var(--color-wood-medium);
}

/* ---- Add to Vocabulary Toggle ---- */
.import-dialog__vocab-toggle {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  padding: var(--space-sm) 0;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.import-dialog__vocab-checkbox {
  width: 20px;
  height: 20px;
  accent-color: var(--color-wood-medium);
  cursor: pointer;
}

.import-dialog__vocab-label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-primary);
}

.import-dialog__vocab-hint {
  font-size: var(--font-size-xs);
  color: var(--color-text-light);
}

/* ---- Import Dialog Actions ---- */
.import-dialog__actions {
  display: flex;
  gap: var(--space-sm);
  padding-top: var(--space-xs);
}

.import-dialog__btn {
  flex: 1 1;
  padding: var(--space-md);
  border-radius: var(--radius-md);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-bold);
  cursor: pointer;
  border: none;
  transition: all var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
  font-family: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-xs);
}

.import-dialog__btn--cancel {
  background-color: var(--color-progress-bg);
  color: var(--color-text-secondary);
}

.import-dialog__btn--cancel:active {
  background-color: var(--color-border);
}

.import-dialog__btn--import {
  background-color: var(--color-success);
  color: white;
  box-shadow: var(--shadow-sm);
}

.import-dialog__btn--import:active:not(:disabled) {
  opacity: 0.85;
}

.import-dialog__btn--import:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ============================================
   IMPORT RESULTS
   ============================================ */

.import-results {
  padding: var(--space-lg);
  background-color: rgba(76, 175, 80, 0.06);
  border: 1.5px solid var(--color-success);
  border-radius: var(--radius-lg);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--space-md);
  text-align: center;
  animation: staged-fade-in 0.3s ease-out;
}

.import-results__icon {
  font-size: 2.5rem;
}

.import-results__title {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: var(--color-success);
}

.import-results__stats {
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
  font-size: var(--font-size-sm);
  color: var(--color-text-secondary);
}

.import-results__stat {
  display: flex;
  align-items: center;
  gap: var(--space-xs);
}

.import-results__stat strong {
  color: var(--color-text-primary);
}

.import-results__errors {
  width: 100%;
  padding: var(--space-sm) var(--space-md);
  background-color: rgba(229, 57, 53, 0.08);
  border-radius: var(--radius-md);
  font-size: var(--font-size-xs);
  color: var(--color-error);
  text-align: left;
}

.import-results__actions {
  display: flex;
  gap: var(--space-sm);
}

@keyframes staged-fade-in {
  0% { opacity: 0; transform: translateY(4px); }
  100% { opacity: 1; transform: translateY(0); }
}`, "",{"version":3,"sources":["webpack://./src/pages/VerbenPage/StagedVerbsSection.css"],"names":[],"mappings":"AAAA,qGAAqG;;AAErG;;iDAEiD;;AAEjD;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,6BAA6B;AAC7B;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,gCAAgC;EAChC,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,SAAO;EACP,wCAAwC;EACxC,uCAAuC;EACvC,+BAA+B;EAC/B,gCAAgC;EAChC,gCAAgC;EAChC,yCAAyC;EACzC,kFAAkF;EAElF,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,YAAY;EACZ,0CAA0C;EAC1C,gCAAgC;EAChC,gCAAgC;EAChC,oCAAoC;EACpC,eAAe;EACf,sCAAsC;EACtC,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;EACxB,yCAAyC;EACzC,uCAAuC;EACvC,+BAA+B;EAC/B,8BAA8B;EAC9B,wCAAwC;EACxC,0BAA0B;EAC1B,iDAAiD;AACnD;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,6BAA6B;EAC7B,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,8BAA8B;AAC9B;EACE,wBAAwB;EACxB,yCAAyC;EACzC,wCAAwC;EACxC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,uCAAuC;EACvC,yCAAyC;EACzC,gCAAgC;EAChC,8BAA8B;EAC9B,wCAAwC;EACxC,eAAe;EACf,sCAAsC;EACtC,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,4BAA4B;AAC5B;EACE,wBAAwB;EACxB,yCAAyC;EACzC,sCAAsC;EACtC,+BAA+B;EAC/B,8BAA8B;EAC9B,wCAAwC;EACxC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;EACE,wBAAwB;EACxB,yCAAyC;EACzC,uCAAuC;EACvC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;EAChC,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA,4BAA4B;AAC5B;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,yCAAyC;EACzC,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;EAC5B,yCAAyC;EACzC,qCAAqC;EACrC,iCAAiC;EACjC,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA,gCAAgC;AAChC;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,8BAA8B;EAC9B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,iCAAiC;EACjC,uCAAuC;EACvC,yCAAyC;EACzC,kCAAkC;EAClC,8BAA8B;EAC9B,wCAAwC;EACxC,eAAe;EACf,sCAAsC;EACtC,mBAAmB;EACnB,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA,qCAAqC;AACrC;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,YAAY;EACZ,sCAAsC;EACtC,YAAY;EACZ,8BAA8B;EAC9B,oCAAoC;EACpC,eAAe;EACf,sCAAsC;EACtC,wCAAwC;EACxC,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,qCAAqC;AACvC;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,oCAAoC;EACpC,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,gCAAgC;EAChC,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,iCAAiC;EACjC,8BAA8B;EAC9B,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,8BAA8B;EAC9B,sCAAsC;EACtC,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,+BAA+B;AAC/B;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,+BAA+B;EAC/B,iBAAiB;EACjB,oCAAoC;EACpC,8BAA8B;EAC9B,0CAA0C;AAC5C;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,oBAAoB;EACpB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,wDAAwD;EACxD,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,gBAAgB;EAChB,MAAM;EACN,yCAAyC;EACzC,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,8BAA8B;EAC9B,8BAA8B;EAC9B,eAAe;EACf,sCAAsC;EACtC,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,wDAAwD;EACxD,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,kCAAkC;EAClC,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,wCAAwC;EACxC,+BAA+B;EAC/B,mDAAmD;EACnD,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,gCAAgC;EAChC,SAAO;AACT;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,6DAA6D;EAC7D,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;EACxC,kCAAkC;EAClC,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA,oCAAoC;AACpC;EACE,wCAAwC;EACxC,yCAAyC;EACzC,aAAa;EACb,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,wBAAwB;EACxB,+BAA+B;EAC/B,gCAAgC;EAChC,oCAAoC;EACpC,eAAe;EACf,YAAY;EACZ,sCAAsC;EACtC,wCAAwC;EACxC,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;iDAEiD;;AAEjD;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,wCAAwC;EACxC,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;EACxC,iCAAiC;EACjC,uCAAuC;EACvC,yCAAyC;EACzC,kCAAkC;EAClC,8BAA8B;EAC9B,wCAAwC;EACxC,eAAe;EACf,sCAAsC;EACtC,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,0BAA0B;EAC1B,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,wBAAwB;EACxB,+BAA+B;EAC/B,gCAAgC;EAChC,oCAAoC;EACpC,eAAe;EACf,YAAY;EACZ,sCAAsC;EACtC,wCAAwC;EACxC,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;iDAEiD;;AAEjD;EACE,wBAAwB;EACxB,yCAAyC;EACzC,wCAAwC;EACxC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,yCAAyC;EACzC,+BAA+B;EAC/B,8BAA8B;EAC9B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,KAAK,UAAU,EAAE,0BAA0B,EAAE;EAC7C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C","sourcesContent":["/* File: /opt/dev_environment/assets/workspace/app-init/src/pages/VerbenPage/StagedVerbsSection.css */\n\n/* ============================================\n   STAGED VERBS SECTION\n   ============================================ */\n\n.staged-verbs {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-md);\n}\n\n/* ---- Add Verb Input ---- */\n.staged-verbs__add-section {\n  background-color: var(--color-card-white);\n  border-radius: var(--radius-lg);\n  padding: var(--space-lg);\n  box-shadow: var(--shadow-md);\n}\n\n.staged-verbs__add-title {\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n  margin-bottom: var(--space-md);\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n}\n\n.staged-verbs__add-form {\n  display: flex;\n  gap: var(--space-sm);\n  align-items: stretch;\n}\n\n.staged-verbs__add-input {\n  flex: 1;\n  padding: var(--space-sm) var(--space-md);\n  border: 1.5px solid var(--color-border);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-base);\n  color: var(--color-text-primary);\n  background-color: var(--color-card-white);\n  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);\n  -webkit-appearance: none;\n  appearance: none;\n  font-family: inherit;\n}\n\n.staged-verbs__add-input:focus {\n  outline: none;\n  border-color: var(--color-wood-medium);\n  box-shadow: 0 0 0 3px rgba(139, 94, 60, 0.15);\n}\n\n.staged-verbs__add-input::placeholder {\n  color: var(--color-text-light);\n}\n\n.staged-verbs__add-input:disabled {\n  opacity: 0.6;\n  background-color: var(--color-progress-bg);\n}\n\n.staged-verbs__add-btn {\n  padding: var(--space-sm) var(--space-lg);\n  border-radius: var(--radius-md);\n  border: none;\n  background-color: var(--color-wood-medium);\n  color: var(--color-text-on-wood);\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-bold);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  font-family: inherit;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  gap: var(--space-xs);\n}\n\n.staged-verbs__add-btn:active:not(:disabled) {\n  background-color: var(--color-wood-dark);\n  transform: scale(0.98);\n}\n\n.staged-verbs__add-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ---- Processing State ---- */\n.staged-verbs__processing {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  padding: var(--space-md);\n  background-color: rgba(255, 143, 0, 0.08);\n  border: 1.5px solid var(--color-accent);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-accent);\n  animation: staged-pulse 1.5s ease-in-out infinite;\n}\n\n@keyframes staged-pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.7; }\n}\n\n.staged-verbs__processing-spinner {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 2px solid currentColor;\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: staged-spin 0.6s linear infinite;\n}\n\n@keyframes staged-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ---- Success Message ---- */\n.staged-verbs__success {\n  padding: var(--space-md);\n  background-color: rgba(76, 175, 80, 0.08);\n  border: 1.5px solid var(--color-success);\n  border-radius: var(--radius-md);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-sm);\n  animation: staged-fade-in 0.3s ease-out;\n}\n\n.staged-verbs__success-header {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-success);\n}\n\n.staged-verbs__success-detail {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n  line-height: var(--line-height-normal);\n}\n\n.staged-verbs__success-detail strong {\n  color: var(--color-text-primary);\n}\n\n.staged-verbs__success-actions {\n  display: flex;\n  gap: var(--space-sm);\n  padding-top: var(--space-xs);\n}\n\n.staged-verbs__success-btn {\n  padding: var(--space-xs) var(--space-md);\n  border-radius: var(--radius-md);\n  border: 1.5px solid var(--color-border);\n  background-color: var(--color-card-white);\n  color: var(--color-text-primary);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  font-family: inherit;\n}\n\n.staged-verbs__success-btn:active {\n  background-color: var(--color-progress-bg);\n}\n\n.staged-verbs__success-btn--primary {\n  background-color: var(--color-wood-medium);\n  color: var(--color-text-on-wood);\n  border-color: var(--color-wood-medium);\n}\n\n.staged-verbs__success-btn--primary:active {\n  background-color: var(--color-wood-dark);\n}\n\n/* ---- Error Message ---- */\n.staged-verbs__error {\n  padding: var(--space-md);\n  background-color: rgba(229, 57, 53, 0.08);\n  border: 1.5px solid var(--color-error);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-error);\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  margin-top: var(--space-md);\n}\n\n/* ---- Duplicate Warning ---- */\n.staged-verbs__duplicate {\n  padding: var(--space-md);\n  background-color: rgba(255, 143, 0, 0.08);\n  border: 1.5px solid var(--color-accent);\n  border-radius: var(--radius-md);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-sm);\n}\n\n.staged-verbs__duplicate-header {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-accent);\n}\n\n.staged-verbs__duplicate-info {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n}\n\n.staged-verbs__duplicate-actions {\n  display: flex;\n  gap: var(--space-sm);\n}\n\n/* ---- Similar Verbs ---- */\n.staged-verbs__similar {\n  padding: var(--space-sm) var(--space-md);\n  background-color: rgba(66, 165, 245, 0.06);\n  border: 1px solid rgba(66, 165, 245, 0.3);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-xs);\n  color: var(--color-text-secondary);\n}\n\n.staged-verbs__similar-title {\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n  margin-bottom: var(--space-xs);\n}\n\n.staged-verbs__similar-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-xs);\n}\n\n.staged-verbs__similar-item {\n  padding: 2px var(--space-sm);\n  background-color: var(--color-card-white);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-full);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-semibold);\n}\n\n/* ---- Staged Verbs List ---- */\n.staged-verbs__list-section {\n  background-color: var(--color-card-white);\n  border-radius: var(--radius-lg);\n  padding: var(--space-lg);\n  box-shadow: var(--shadow-md);\n}\n\n.staged-verbs__list-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: var(--space-md);\n  flex-wrap: wrap;\n  gap: var(--space-sm);\n}\n\n.staged-verbs__list-title {\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n}\n\n.staged-verbs__list-actions {\n  display: flex;\n  gap: var(--space-sm);\n  align-items: center;\n}\n\n/* ---- Status Filter ---- */\n.staged-verbs__filter-bar {\n  display: flex;\n  gap: var(--space-xs);\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n  padding: var(--space-xs) 0;\n  margin-bottom: var(--space-sm);\n}\n\n.staged-verbs__filter-bar::-webkit-scrollbar {\n  display: none;\n}\n\n.staged-verbs__filter-btn {\n  padding: var(--space-xs) var(--space-sm);\n  border-radius: var(--radius-full);\n  border: 1.5px solid var(--color-border);\n  background-color: var(--color-card-white);\n  color: var(--color-text-secondary);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-semibold);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  white-space: nowrap;\n  -webkit-tap-highlight-color: transparent;\n  font-family: inherit;\n}\n\n.staged-verbs__filter-btn--active {\n  background-color: var(--color-wood-medium);\n  color: var(--color-text-on-wood);\n  border-color: var(--color-wood-medium);\n}\n\n/* ---- Import Selected Button ---- */\n.staged-verbs__import-selected-btn {\n  padding: var(--space-xs) var(--space-md);\n  border-radius: var(--radius-md);\n  border: none;\n  background-color: var(--color-success);\n  color: white;\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-bold);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  font-family: inherit;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  gap: var(--space-xs);\n}\n\n.staged-verbs__import-selected-btn:active:not(:disabled) {\n  opacity: 0.85;\n  transform: scale(0.98);\n}\n\n.staged-verbs__import-selected-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* ---- Verb List Table ---- */\n.staged-verbs__table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  overflow: hidden;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--color-border);\n}\n\n.staged-verbs__table thead {\n  background: linear-gradient(180deg, #f5efe6 0%, #ede4d6 100%);\n}\n\n.staged-verbs__table th {\n  padding: var(--space-sm) var(--space-sm);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-wood-dark);\n  text-align: left;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  border-bottom: 2px solid var(--color-border);\n  white-space: nowrap;\n}\n\n.staged-verbs__table th:first-child {\n  width: 36px;\n  text-align: center;\n}\n\n.staged-verbs__table td {\n  padding: var(--space-sm) var(--space-sm);\n  font-size: var(--font-size-sm);\n  color: var(--color-text-primary);\n  border-bottom: 1px solid var(--color-border);\n  vertical-align: middle;\n}\n\n.staged-verbs__table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.staged-verbs__table tbody tr:nth-child(even) {\n  background-color: rgba(245, 239, 230, 0.4);\n}\n\n.staged-verbs__table-checkbox {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  accent-color: var(--color-wood-medium);\n}\n\n.staged-verbs__table-checkbox:disabled {\n  cursor: not-allowed;\n  opacity: 0.4;\n}\n\n/* ---- Status Badge ---- */\n.staged-verbs__status-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 2px var(--space-sm);\n  border-radius: var(--radius-full);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-bold);\n  white-space: nowrap;\n}\n\n/* ---- Table Action Buttons ---- */\n.staged-verbs__table-actions {\n  display: flex;\n  gap: 2px;\n  white-space: nowrap;\n}\n\n.staged-verbs__table-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: var(--radius-sm);\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-size: var(--font-size-sm);\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  padding: 0;\n}\n\n.staged-verbs__table-action-btn:hover {\n  background-color: var(--color-progress-bg);\n}\n\n.staged-verbs__table-action-btn:active {\n  transform: scale(0.92);\n}\n\n.staged-verbs__table-action-btn--delete {\n  color: var(--color-error);\n}\n\n.staged-verbs__table-action-btn--delete:hover {\n  background-color: rgba(229, 57, 53, 0.1);\n}\n\n.staged-verbs__table-action-btn--retry {\n  color: var(--color-accent);\n}\n\n.staged-verbs__table-action-btn--retry:hover {\n  background-color: rgba(255, 143, 0, 0.1);\n}\n\n/* ---- Verb Group Badge ---- */\n.staged-verbs__group-badge {\n  display: inline-block;\n  padding: 1px var(--space-xs);\n  border-radius: var(--radius-sm);\n  font-size: 0.6rem;\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-light);\n  background-color: var(--color-progress-bg);\n}\n\n/* ---- Empty State ---- */\n.staged-verbs__empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-xl) var(--space-md);\n  gap: var(--space-sm);\n  text-align: center;\n  color: var(--color-text-secondary);\n}\n\n.staged-verbs__empty-icon {\n  font-size: 2rem;\n}\n\n.staged-verbs__empty-text {\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-normal);\n  max-width: 280px;\n}\n\n/* ============================================\n   VERB DETAIL DIALOG\n   ============================================ */\n\n.verb-detail-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 200;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--space-md);\n  animation: overlay-fade-in 0.2s ease-out;\n}\n\n.verb-detail-dialog {\n  background-color: var(--color-card-white);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  width: 100%;\n  max-width: 440px;\n  max-height: 85vh;\n  overflow-y: auto;\n  animation: dialog-slide-up 0.25s ease-out;\n  display: flex;\n  flex-direction: column;\n}\n\n.verb-detail-dialog__header {\n  padding: var(--space-lg) var(--space-lg) var(--space-sm);\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  position: sticky;\n  top: 0;\n  background-color: var(--color-card-white);\n  z-index: 2;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.verb-detail-dialog__header-info {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.verb-detail-dialog__title {\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-extrabold);\n  color: var(--color-wood-medium);\n}\n\n.verb-detail-dialog__subtitle {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n  font-weight: var(--font-weight-semibold);\n}\n\n.verb-detail-dialog__meta {\n  display: flex;\n  gap: var(--space-xs);\n  align-items: center;\n  margin-top: var(--space-xs);\n}\n\n.verb-detail-dialog__close {\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-full);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  font-size: var(--font-size-lg);\n  color: var(--color-text-light);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  flex-shrink: 0;\n  font-family: inherit;\n}\n\n.verb-detail-dialog__close:hover {\n  background-color: var(--color-progress-bg);\n  color: var(--color-text-primary);\n}\n\n.verb-detail-dialog__body {\n  padding: var(--space-md) var(--space-lg) var(--space-lg);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-md);\n}\n\n/* ---- Tense Selection ---- */\n.verb-detail__tense-section {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-sm);\n}\n\n.verb-detail__tense-section-label {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-secondary);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.verb-detail__tense-list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-xs);\n}\n\n.verb-detail__tense-item {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  padding: var(--space-xs) var(--space-sm);\n  border-radius: var(--radius-md);\n  transition: background-color var(--transition-fast);\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.verb-detail__tense-item:hover {\n  background-color: rgba(139, 94, 60, 0.04);\n}\n\n.verb-detail__tense-checkbox {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  accent-color: var(--color-wood-medium);\n  flex-shrink: 0;\n}\n\n.verb-detail__tense-label {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-primary);\n  flex: 1;\n}\n\n.verb-detail__tense-german {\n  font-size: var(--font-size-xs);\n  color: var(--color-text-light);\n}\n\n/* ---- Conjugation Tables ---- */\n.verb-detail__conjugation-section {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-md);\n}\n\n.verb-detail__conjugation-table-wrapper {\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-md);\n  overflow: hidden;\n}\n\n.verb-detail__conjugation-table-header {\n  padding: var(--space-sm) var(--space-md);\n  background: linear-gradient(180deg, #f5efe6 0%, #ede4d6 100%);\n  border-bottom: 1px solid var(--color-border);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.verb-detail__conjugation-table-title {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-wood-dark);\n}\n\n.verb-detail__conjugation-table-german {\n  font-size: var(--font-size-xs);\n  color: var(--color-text-light);\n}\n\n.verb-detail__conjugation-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.verb-detail__conjugation-table td {\n  padding: var(--space-xs) var(--space-sm);\n  font-size: var(--font-size-sm);\n  border-bottom: 1px solid var(--color-border);\n  vertical-align: middle;\n}\n\n.verb-detail__conjugation-table tr:last-child td {\n  border-bottom: none;\n}\n\n.verb-detail__conjugation-table tr:nth-child(even) {\n  background-color: rgba(245, 239, 230, 0.3);\n}\n\n.verb-detail__conj-person {\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-secondary);\n  width: 70px;\n  white-space: nowrap;\n}\n\n.verb-detail__conj-italian {\n  font-weight: var(--font-weight-bold);\n  color: var(--color-wood-medium);\n}\n\n.verb-detail__conj-german {\n  font-size: var(--font-size-xs);\n  color: var(--color-text-light);\n}\n\n/* ---- Detail Footer Actions ---- */\n.verb-detail-dialog__footer {\n  padding: var(--space-md) var(--space-lg);\n  border-top: 1px solid var(--color-border);\n  display: flex;\n  gap: var(--space-sm);\n  position: sticky;\n  bottom: 0;\n  background-color: var(--color-card-white);\n  z-index: 2;\n}\n\n.verb-detail__action-btn {\n  flex: 1;\n  padding: var(--space-md);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-bold);\n  cursor: pointer;\n  border: none;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  font-family: inherit;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-xs);\n}\n\n.verb-detail__action-btn--delete {\n  background-color: transparent;\n  color: var(--color-error);\n  border: 1.5px solid var(--color-error);\n}\n\n.verb-detail__action-btn--delete:active {\n  background-color: rgba(229, 57, 53, 0.1);\n}\n\n.verb-detail__action-btn--import {\n  background-color: var(--color-success);\n  color: white;\n  box-shadow: var(--shadow-sm);\n}\n\n.verb-detail__action-btn--import:active:not(:disabled) {\n  opacity: 0.85;\n}\n\n.verb-detail__action-btn--import:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* ============================================\n   IMPORT DIALOG\n   ============================================ */\n\n.import-dialog {\n  background-color: var(--color-card-white);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  width: 100%;\n  max-width: 380px;\n  padding: var(--space-lg);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-md);\n  animation: dialog-slide-up 0.25s ease-out;\n}\n\n.import-dialog__icon {\n  font-size: 2.5rem;\n  text-align: center;\n  line-height: 1;\n}\n\n.import-dialog__title {\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-primary);\n  text-align: center;\n}\n\n.import-dialog__summary {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-xs);\n  padding: var(--space-sm) var(--space-md);\n  background-color: rgba(139, 94, 60, 0.06);\n  border-radius: var(--radius-md);\n}\n\n.import-dialog__summary-item {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n  display: flex;\n  align-items: center;\n  gap: var(--space-xs);\n}\n\n.import-dialog__summary-item strong {\n  color: var(--color-text-primary);\n}\n\n.import-dialog__total {\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-wood-medium);\n  text-align: center;\n  padding: var(--space-sm) 0;\n  border-top: 1px solid var(--color-border);\n  margin-top: var(--space-xs);\n}\n\n/* ---- Tense Override ---- */\n.import-dialog__tense-override {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-sm);\n}\n\n.import-dialog__tense-override-label {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text-secondary);\n}\n\n.import-dialog__tense-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-xs);\n}\n\n.import-dialog__tense-chip {\n  padding: var(--space-xs) var(--space-sm);\n  border-radius: var(--radius-full);\n  border: 1.5px solid var(--color-border);\n  background-color: var(--color-card-white);\n  color: var(--color-text-secondary);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-semibold);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  font-family: inherit;\n}\n\n.import-dialog__tense-chip--selected {\n  background-color: var(--color-wood-medium);\n  color: var(--color-text-on-wood);\n  border-color: var(--color-wood-medium);\n}\n\n/* ---- Add to Vocabulary Toggle ---- */\n.import-dialog__vocab-toggle {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  padding: var(--space-sm) 0;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.import-dialog__vocab-checkbox {\n  width: 20px;\n  height: 20px;\n  accent-color: var(--color-wood-medium);\n  cursor: pointer;\n}\n\n.import-dialog__vocab-label {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text-primary);\n}\n\n.import-dialog__vocab-hint {\n  font-size: var(--font-size-xs);\n  color: var(--color-text-light);\n}\n\n/* ---- Import Dialog Actions ---- */\n.import-dialog__actions {\n  display: flex;\n  gap: var(--space-sm);\n  padding-top: var(--space-xs);\n}\n\n.import-dialog__btn {\n  flex: 1;\n  padding: var(--space-md);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-bold);\n  cursor: pointer;\n  border: none;\n  transition: all var(--transition-fast);\n  -webkit-tap-highlight-color: transparent;\n  font-family: inherit;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--space-xs);\n}\n\n.import-dialog__btn--cancel {\n  background-color: var(--color-progress-bg);\n  color: var(--color-text-secondary);\n}\n\n.import-dialog__btn--cancel:active {\n  background-color: var(--color-border);\n}\n\n.import-dialog__btn--import {\n  background-color: var(--color-success);\n  color: white;\n  box-shadow: var(--shadow-sm);\n}\n\n.import-dialog__btn--import:active:not(:disabled) {\n  opacity: 0.85;\n}\n\n.import-dialog__btn--import:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* ============================================\n   IMPORT RESULTS\n   ============================================ */\n\n.import-results {\n  padding: var(--space-lg);\n  background-color: rgba(76, 175, 80, 0.06);\n  border: 1.5px solid var(--color-success);\n  border-radius: var(--radius-lg);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--space-md);\n  text-align: center;\n  animation: staged-fade-in 0.3s ease-out;\n}\n\n.import-results__icon {\n  font-size: 2.5rem;\n}\n\n.import-results__title {\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-success);\n}\n\n.import-results__stats {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-xs);\n  font-size: var(--font-size-sm);\n  color: var(--color-text-secondary);\n}\n\n.import-results__stat {\n  display: flex;\n  align-items: center;\n  gap: var(--space-xs);\n}\n\n.import-results__stat strong {\n  color: var(--color-text-primary);\n}\n\n.import-results__errors {\n  width: 100%;\n  padding: var(--space-sm) var(--space-md);\n  background-color: rgba(229, 57, 53, 0.08);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-xs);\n  color: var(--color-error);\n  text-align: left;\n}\n\n.import-results__actions {\n  display: flex;\n  gap: var(--space-sm);\n}\n\n@keyframes staged-fade-in {\n  0% { opacity: 0; transform: translateY(4px); }\n  100% { opacity: 1; transform: translateY(0); }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
